import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-top-bca-colleges-in-india',
  templateUrl: './top-bca-colleges-in-india.component.html',
  styleUrls: ['./top-bca-colleges-in-india.component.scss']
})
export class TopBCACollegesInIndiaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
